import styled from 'styled-components';
import { FlexView } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import COLORS from 'constants/colors';

export const RowContainer = styled(FlexView)`
  border-bottom: 1px solid ${COLORS.GREY_2};
  cursor: pointer;
  transition: opacity 0.15s ease;
  background: ${({ bg }) => bg || COLORS.TRANSPARENT};

  &:hover {
    opacity: 0.8;
  }
  gap: 16px;

  > :last-child {
    margin-left: auto;
  }
`;

export const EventIndexCell = styled(FlexView)`
  min-width: 64px;
`;

export const EventVerdictCell = styled(FlexView)`
  min-width: 190px;
  flex-direction: row;
  gap: 4px;
  > div:first-child {
    font-weight: 500;
  }
`;

export const ChunkCountCell = styled(FlexView)`
  min-width: 80px;
`;

export const DurationCell = styled(FlexView)`
  min-width: 64px;
`;

export const ButtonText = styled(Text)`
  font-size: 12px;
`;
